class ToggleImageShowcase extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
    this.handleTrackClick = this.handleTrackClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
  }

  connectedCallback() {
    this.tabsList = this.querySelector('[data-toggle-tabs]');
    this.tabs = Array.from(this.querySelectorAll('[data-toggle-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-toggle-panel]'));

    this.tabsList?.addEventListener('click', this.handleTrackClick);

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', this.handleClick);
      tab.addEventListener('keydown', this.handleKeydown);
    });

    const selectedTab = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true');
    const defaultOption = this.dataset.defaultOption || this.tabs[0]?.dataset.option;
    this.selectOption(selectedTab?.dataset.option || defaultOption, false);
  }

  disconnectedCallback() {
    this.tabsList?.removeEventListener('click', this.handleTrackClick);

    this.tabs?.forEach((tab) => {
      tab.removeEventListener('click', this.handleClick);
      tab.removeEventListener('keydown', this.handleKeydown);
    });
  }

  handleClick(event) {
    this.selectOption(event.currentTarget.dataset.option, true);
  }

  handleTrackClick(event) {
    if (event.target.closest('[data-toggle-tab]')) return;

    const rect = this.tabsList.getBoundingClientRect();
    const pointerX = event.clientX - rect.left;
    const optionIndex = pointerX < rect.width / 2 ? 0 : 1;
    const option = this.tabs[optionIndex]?.dataset.option;

    this.selectOption(option, false);
  }

  handleKeydown(event) {
    const currentIndex = this.tabs.indexOf(event.currentTarget);
    let nextIndex = currentIndex;

    switch (event.key) {
      case 'Enter':
      case ' ':
        event.preventDefault();
        this.selectOption(event.currentTarget.dataset.option, true);
        return;
      case 'ArrowRight':
      case 'ArrowDown':
        event.preventDefault();
        nextIndex = (currentIndex + 1) % this.tabs.length;
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        event.preventDefault();
        nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        break;
      case 'Home':
        event.preventDefault();
        nextIndex = 0;
        break;
      case 'End':
        event.preventDefault();
        nextIndex = this.tabs.length - 1;
        break;
      default:
        return;
    }

    const nextTab = this.tabs[nextIndex];
    nextTab?.focus();
    this.selectOption(nextTab?.dataset.option, true);
  }

  selectOption(option, moveFocus) {
    if (!option) return;

    this.dataset.activeOption = option;
    if (this.tabsList) this.tabsList.dataset.activeOption = option;

    this.tabs.forEach((tab) => {
      const isActive = tab.dataset.option === option;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.tabIndex = isActive ? 0 : -1;
      if (isActive && moveFocus) tab.focus();
    });

    this.panels.forEach((panel) => {
      const isActive = panel.dataset.option === option;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  }
}

if (!customElements.get('toggle-image-showcase')) {
  customElements.define('toggle-image-showcase', ToggleImageShowcase);
}
